module.exports = __webpack_public_path__ + "static/media/check-green.8de0bbf9.svg";